// @ts-nocheck
/* eslint-disable */
'use strict';

function toMinutes(value) {
  const match = /^(\d{2}):(\d{2})$/.exec(value || '');
  if (!match) return NaN;
  const h = Number(match[1]);
  const m = Number(match[2]);
  if (h > 23 || m > 59) return NaN;
  return h * 60 + m;
}

function toTime(minutes) {
  return `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
}

function overlaps(aStart, aEnd, bStart, bEnd) {
  return toMinutes(aStart) < toMinutes(bEnd) && toMinutes(aEnd) > toMinutes(bStart);
}

function contains(outerStart, outerEnd, innerStart, innerEnd) {
  return toMinutes(innerStart) >= toMinutes(outerStart) && toMinutes(innerEnd) <= toMinutes(outerEnd);
}

function validateRange(start, end, options = {}) {
  const minDuration = options.minDuration ?? 30;
  const dayStart = options.dayStart ?? '08:00';
  const dayEnd = options.dayEnd ?? '20:00';
  const s = toMinutes(start); const e = toMinutes(end);
  const ds = toMinutes(dayStart); const de = toMinutes(dayEnd);
  if (![s,e,ds,de].every(Number.isFinite)) return {ok:false, reason:'invalid-time'};
  if (s < ds || e > de || s >= e) return {ok:false, reason:'invalid-range'};
  if (e - s < minDuration) return {ok:false, reason:'minimum-duration'};
  return {ok:true};
}

function exactRange(a, b) {
  return a.start === b.start && a.end === b.end;
}

function fragmentsAfterAvailabilityEdit(slot, editStart, editEnd, options = {}) {
  const rangeCheck = validateRange(editStart, editEnd, {...options, minDuration: 1});
  if (!rangeCheck.ok) return rangeCheck;
  if (!contains(slot.start, slot.end, editStart, editEnd)) return {ok:false, reason:'outside-source'};
  const minDuration = options.minDuration ?? 30;
  const fragments = [];
  if (toMinutes(editStart) > toMinutes(slot.start)) fragments.push({start:slot.start,end:editStart});
  if (toMinutes(editEnd) < toMinutes(slot.end)) fragments.push({start:editEnd,end:slot.end});
  if (fragments.some(x => toMinutes(x.end) - toMinutes(x.start) < minDuration)) {
    return {ok:false, reason:'fragment-too-short'};
  }
  return {ok:true, fragments};
}

function availabilityOverlaps(items, weekday, start, end, excludeId = null) {
  return items.some(x => x.id !== excludeId && x.weekday === weekday && overlaps(start,end,x.start,x.end));
}

function createAvailability(items, candidate, options = {}) {
  const valid = validateRange(candidate.start,candidate.end,options);
  if (!valid.ok) return valid;
  const exact = items.find(x => x.weekday===candidate.weekday && exactRange(x,candidate));
  if (exact) return {ok:true, existing:exact, created:false};
  if (availabilityOverlaps(items,candidate.weekday,candidate.start,candidate.end)) return {ok:false,reason:'availability-overlap'};
  const item = {...candidate, id:candidate.id ?? `a_${Date.now()}_${Math.random().toString(36).slice(2,7)}`};
  items.push(item);
  return {ok:true,item,created:true};
}

function updateAvailability(items, id, patch, reservations = [], options = {}) {
  const item = items.find(x => x.id === id);
  if (!item) return {ok:false,reason:'not-found'};
  const valid = validateRange(patch.start,patch.end,options);
  if (!valid.ok) return valid;
  if (availabilityOverlaps(items,item.weekday,patch.start,patch.end,id)) return {ok:false,reason:'availability-overlap'};
  const previous = {start:item.start,end:item.end};
  item.start=patch.start; item.end=patch.end;
  return {ok:true,item,previous};
}

// Editar, recortar o eliminar disponibilidad nunca modifica las reservas confirmadas.
// Esta operación retira únicamente la franja de la oferta para nuevas reservas.
function deleteAvailability(items, id) {
  const idx=items.findIndex(x=>x.id===id);
  if(idx<0) return {ok:false,reason:'not-found'};
  const [removed]=items.splice(idx,1);
  return {ok:true,removed};
}

function editAvailability(items, id, editStart, editEnd, reservations = [], options = {}) {
  const item = items.find(x => x.id === id);
  if (!item) return {ok:false,reason:'not-found'};
  const result = fragmentsAfterAvailabilityEdit(item,editStart,editEnd,options);
  if (!result.ok) return result;
  const idx = items.findIndex(x => x.id === id);
  const fragments = result.fragments.map((x,i)=>({
    id: `${id}_part_${i+1}_${Math.random().toString(36).slice(2,6)}`,
    weekday:item.weekday,
    start:x.start,
    end:x.end
  }));
  items.splice(idx,1,...fragments);
  return {ok:true,fragments,removed:fragments.length===0};
}

function applyRangeToDays(items, sourceDay, targetDays, range, options = {}) {
  const result={applied:0,alreadyPresent:0,skipped:0};
  for (const weekday of [...new Set(targetDays)].filter(d=>d!==sourceDay)) {
    const exact=items.find(x=>x.weekday===weekday&&x.start===range.start&&x.end===range.end);
    if (exact) { result.alreadyPresent++; continue; }
    const created=createAvailability(items,{weekday,start:range.start,end:range.end},options);
    if (created.ok) result.applied++; else result.skipped++;
  }
  return result;
}

function updateCounterparts(items, sourceDay, targetDays, previousRange, nextRange, reservations = [], options = {}) {
  const result={applied:0,alreadyPresent:0,skipped:0};
  for (const weekday of [...new Set(targetDays)].filter(d=>d!==sourceDay)) {
    const counterpart=items.find(x=>x.weekday===weekday&&x.start===previousRange.start&&x.end===previousRange.end);
    if (counterpart) {
      const updated=updateAvailability(items,counterpart.id,nextRange,reservations,options);
      if (updated.ok) result.applied++; else result.skipped++;
      continue;
    }
    const exact=items.find(x=>x.weekday===weekday&&x.start===nextRange.start&&x.end===nextRange.end);
    if (exact) { result.alreadyPresent++; continue; }
    const created=createAvailability(items,{weekday,start:nextRange.start,end:nextRange.end},options);
    if (created.ok) result.applied++; else result.skipped++;
  }
  return result;
}

function applyAvailabilityEditToDays(items, sourceDay, targetDays, editStart, editEnd, reservations = [], options = {}) {
  const result={applied:0,skipped:0};
  for (const weekday of [...new Set(targetDays)].filter(d=>d!==sourceDay)) {
    const container=items.find(x=>x.weekday===weekday&&contains(x.start,x.end,editStart,editEnd));
    if (!container) { result.skipped++; continue; }
    const edited=editAvailability(items,container.id,editStart,editEnd,reservations,options);
    if (edited.ok) result.applied++; else result.skipped++;
  }
  return result;
}

function normalizeIntervals(intervals) {
  return intervals.map(x=>({start:x.start,end:x.end})).sort((a,b)=>toMinutes(a.start)-toMinutes(b.start));
}

export {
  toMinutes, toTime, overlaps, contains, validateRange, fragmentsAfterAvailabilityEdit,
  createAvailability, updateAvailability, deleteAvailability, editAvailability, applyRangeToDays,
  updateCounterparts, applyAvailabilityEditToDays, normalizeIntervals
};
